<template>
  <div class='container'>
      <ul class="list" v-show="dataTable.length > 0">
        <p>共：{{dataTable.length}}人</p>
        <li
          class="student"
          v-for="(item, index) in dataTable"
          :key="index"
        >
         <span class="head" v-if="item.Icon"><img :src="item.Icon"></span>
         <span class="head" v-else>{{xy.showName(item.FullName)}}</span>
          <!-- <Avatar :iconPath="item.Icon" :fullName="item.FullName" class="avatar"></Avatar> -->
          <div class="name">
            <div class="title">
              <span>{{ item.FullName }}</span>
              <span class="UserName">{{item.UserName}}</span>
            </div>
            <span class="person">{{item.TotalScore}} <span>分</span></span>
          </div>
        </li>
        <p style="color:#999999;font-size:14px;text-align:center;margin-top:20px;">--  没有更多了 --</p>
      </ul>
  </div>
</template>

<script>
// import Avatar from '@/pages/attendance/components/Avatar.vue'
export default {
  name: '',
    components: {
    // Avatar
  },
  data () {
    return {
      dataTable:[],
      obj:{},
    }
  },
  created () {
    this.obj = this.$store.state.evaluation.averageObj
    this.fetchRightStudentList()
  },
  methods: {
     async fetchRightStudentList () {
        let params = {
          coursePlanAID: this.obj.CoursePlanAID,
          classTableGenerateBaseID: this.obj.ClassTableGenerateBaseID,
          coursePlanAIDType: this.obj.CoursePlanAIDType,
          studentOrganizationID: this.obj.StudentOrganizationID
        }
        this.xy.loading()
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/EvaluateStudent/GetStudentScoreList`, params)
        this.xy.unloading()
        if (res.success) {
          this.dataTable = []
          if (res.data.length > 0) {
            this.dataTable = res.data
          }
        }
      },
  },
  mounted () {}
}
</script>

<style lang='less' scoped>
.head {
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    text-align: left;
    border-radius: 50%;
    background: @blue;
    font-size: 30px;
    color: #fff;
    > img {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 50%;
    }
  }
.list{
  padding:35px;
  padding-bottom:100px;
  li{
   margin-top:20px;
   padding:27px 29px;
   border-radius: 8px;
   background: #fff;
   display: flex;
   align-items: center;
    // height: 122px;
    // line-height: 122px;
    .UserName{
      color:#ABABB0;
    }
    .person{
      font-size: 34px;
      color: rgba(255,96,16,1);
      span{
        font-size: 22px;
      }
    }
    .name{
      flex:1;
      display: flex;
      margin-left:20px;
      justify-content: space-between;
      // align-items: flex-end;
      align-items:center;
      .title{
        display: flex;
        flex-direction: column;
        span{
          height:40px;
        }
      }
    }
  }
}
</style>
